export const showAnnualReceiptBanner = function () {
    const currentDate = new Date();

    dcLocalStorage.requestCrossDomainValue('xAnnualReceiptBanner', function (key, value) {
        if (value == null) {
            if (typeof userObj !== 'undefined' &&
                userObj.hasGreenDollars &&
                (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() <= 15))) {
                $('#annual-receipt-banner').show();
            }
        }
    });
};

export const hideAnnualReceiptBanner = function () {
    const lastDayOfYear = new Date((new Date()).getFullYear(), 11, 31);
    const ttl = lastDayOfYear - (new Date()).getTime();
    dcLocalStorage.setCrossDomainValue('xAnnualReceiptBanner', 'true', ttl);
    $('#annual-receipt-banner').hide();
};
